import { render, staticRenderFns } from "./UserStatus.vue?vue&type=template&id=3fd04fa2&scoped=true&"
import script from "./UserStatus.vue?vue&type=script&lang=js&"
export * from "./UserStatus.vue?vue&type=script&lang=js&"
import style0 from "./UserStatus.vue?vue&type=style&index=0&id=3fd04fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd04fa2",
  null
  
)

export default component.exports